/*export function newId (prefix = 'id'): string {
    return `${prefix}_${crypto.randomUUID()}`;
}*/
export function newId(prefix = 'id'): string {
  let uuid: string;

  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    uuid = crypto.randomUUID();
  } else {
    uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  return `${prefix}_${uuid}`;
}
export function getOrCreateSessionId (): string {
    const k = 'sessionId';
    let v = sessionStorage.getItem(k);
    if (!v) { v = newId('sess'); sessionStorage.setItem(k, v); }
    return v;
}